module.exports = __webpack_public_path__ + "static/media/caballeroBlue.a7beb60c.svg";